import axios from './http';
import qs from 'qs';
import { Message } from 'element-ui';
export function postJson(urlData, paramData) {
    return new Promise((resolve, reject) => {
        axios.post(urlData, paramData).then(function (response) {
            if (response.resultCode != 200) {
                if (urlData=="/teacher/getUserGroupList") {
                    console.log(" 解决 查询分组方案下的 分组信息，没有数据会报错。",urlData);
                } else {
                    Message({
                        message: response.msg,
                        type: "error",
                        duration: 2000,
                    });
                }

                //把不是 200的结果给catch 处理
                reject(response);
            } else if (response.resultCode === 200) {
                resolve(response.data);// 只有 200 才走 then  其余 catch
            }
        }).catch(function (error) {
            Message({
                message: error,
                type: "error",
                duration: 2000,
            });
            reject(error);
        });
    });
}

export function postData(urlData, paramData) {
    return new Promise((resolve, reject) => {
        axios.post(urlData, qs.stringify(paramData))
            .then(function (response) {
                // data: {id: 1, userId: "111", userCode: "admin", userName: "管理员", userType: "admin", …}
                // msg: "成功"
                // resultCode: 200
                // success: true
                // time: "2021-05-18 15:06:27"

                // msg: "验证码错误"
                // resultCode: 20011
                // success: false
                // time: "2021-05-18 15:15:53"
                if (response.resultCode != 200) {
                    Message({
                        message: response.msg,
                        type: "error",
                        duration: 2000,
                    });
                   
                    //把不是 200的结果给catch 处理
                    reject(response);
                } else if (response.resultCode === 200) {
                    resolve(response.data);// 只有 200 才走 then  其余 catch
                }
            }).catch(function (error) {
                Message({
                    message: error,
                    type: "error",
                    duration: 2000,
                });
                reject(error);
            });
    });
}

//   {
//     params: {
//       username: 'pp', password: 123456
//     }
//     responseType: "blob"
//   }
export function getData(urlData, paramData,config) {
    return new Promise((resolve, reject) => {
        axios.get(urlData, { params: paramData,...config }).then(function (response) {
            if(response.resultCode){
                if (response.resultCode != 200) {
                    Message({
                        message: response.msg,
                        type: "error",
                        duration: 2000,
                    });
                    reject(response);
                } else if (response.resultCode === 200) {
                    resolve(response.data);
                }
            }else{
                resolve(response)
            }
           
        }).catch(function (error) {
            Message({
                message: error,
                type: "error",
                duration: 2000,
            });
            reject(error);
        });
    });
}

export function postFile(urlData, paramData) {
    return new Promise((resolve, reject) => {
        axios.post(urlData, paramData)
            .then(function (response) {          
                if(response.resultCode){
                    if (response.resultCode != 200) {                  
                        Message({
                            message: response.msg,
                            type: "error",
                            duration: 2000,
                        });
                        reject(response);
                    } else if (response.resultCode === 200) {
                        resolve(response.data);
                    }
                }else{
                    resolve(response)
                }
            }).catch(function (error) {
                Message({
                    message: error,
                    type: "error",
                    duration: 2000,
                });
                reject(error);
            });
    });
}



